import React, { Fragment } from 'react';

// DASHBOARDS
// import PrivateRoutes from '../../routes/PrivateRoutes';
import PrivateRoutes from '../../../routes/PrivateRoutes';

// Layout

import AppHeader from '../../AppHeader';
import AppSidebar from '../../AppSidebar';
import AppFooter from '../../AppFooter';

const Dashboards = ({ match }) => (
  <>
    <AppHeader />
    <div className="app-main">
      <AppSidebar />
      <div className="app-main__outer">
        <div className="app-main__inner">
          <PrivateRoutes />
        </div>
        {/* <AppFooter /> */}
      </div>
    </div>
  </>
);

export default Dashboards;
